import axios from "axios";
import config from "../utils/config";

const axiosInstance = axios.create({
  baseURL: config.api.baseURL + "/",
  timeout: 10000, // 10 second timeout to prevent hanging on slow/dead connections
  headers: {
    // This header bypasses ngrok's warning page
    "ngrok-skip-browser-warning": "true"
  }
});


// Request interceptor
axiosInstance.interceptors.request.use(
  (reqConfig) => {
    // Always add ngrok bypass header
    reqConfig.headers = reqConfig.headers || {};
    reqConfig.headers["ngrok-skip-browser-warning"] = "true";
    return reqConfig;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Modify response data or handle success
    return response;
  },
  async (error) => {
    // Handle response errors - MUST reject to properly handle errors
    console.error('❌ Axios Error:', error.response?.status, error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
